import React from 'react';
import { CharacterStats, StatType } from '../../../../../shared/CharacterTypes';
import { Tooltip, TooltipData } from '../../../components/Tooltip';
import { createStatTooltipData, formatStatValue } from './StatHelpers';

export interface StatLedgerRowProps {
  abbreviation: string;
  label: string;
  value: number | undefined;
  description: string;
  formatValue?: (value: number) => string;
  action?: React.ReactNode;
  statType?: StatType;
  stats?: CharacterStats;
  characterClass?: string;
  statPoints?: number;
  tooltipData?: TooltipData | null;
}

export const StatLedgerRow: React.FC<StatLedgerRowProps> = ({
  abbreviation,
  label,
  value,
  description,
  formatValue,
  action,
  statType,
  stats,
  characterClass,
  statPoints,
  tooltipData,
}) => {
  const available = typeof value === 'number' && Number.isFinite(value);
  const formatter = formatValue ?? ((v: number) => formatStatValue(v, statType));
  const resolvedTooltip = tooltipData !== undefined
    ? tooltipData
    : (statType ? createStatTooltipData(statType, value, stats, characterClass, statPoints) : null);

  const rowContent = (
    <div className="character-stat-row" role="listitem">
      <div className="character-stat-row__heading">
        <span className="character-stat-row__abbreviation" aria-hidden="true">{abbreviation}</span>
        <span className="character-stat-row__label">{label}</span>
      </div>
      <span
        className="character-stat-row__value"
        aria-label={`${label}: ${available ? formatter(value) : 'unavailable'}`}
      >
        {available ? formatter(value) : '—'}
      </span>
      <span className="character-stat-row__description">{description}</span>
      {action ? <span className="character-stat-row__action">{action}</span> : null}
    </div>
  );

  if (resolvedTooltip) {
    return (
      <Tooltip data={resolvedTooltip}>
        {rowContent}
      </Tooltip>
    );
  }

  return rowContent;
};
